export default __webpack_public_path__ + "static/media/css_html.14c3065e.svg";